import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/gruh-udhyog/product-variants";

export const Route = createFileRoute(
  "/admin/_modules/_gruh-udhyog/product-variants"
)({
  component: Page,
});
